import { MEDIA_DOMAIN2 } from '@constants';
import { ImageType } from '@types';
import { getMediaUrl, getSysUrl, getThumbUrl } from '@utils/urlMakers';
import type { CSSProperties } from 'react';
import styled from 'styled-components';

interface Props {
  type?: ImageType;
  size?: number;
  src: string;
  objectFit?: CSSProperties['objectFit'];
}

const Image = styled.img.attrs<Props>(({ type, size, src }) => {
  if (!type) return { src };
  let url = '';
  if (type === ImageType.thumb) {
    url = getThumbUrl(src);
    if (size) {
      url += `?x-oss-process=image/auto-orient,1/resize,s_${size * 2},m_lfit`;
    }
  } else if (type === ImageType.media) {
    url = getMediaUrl(src);
    if (size) {
      url += `?imageMogr2/auto-orient/thumbnail/${size * 2}`;
    }
  } else if (type === ImageType.sysMedia) {
    url = getSysUrl(src);
  } else if (type === ImageType.watermark) {
    url = `${MEDIA_DOMAIN2}${src}`;
    if (size) {
      url += `?x-oss-process=image/auto-orient,1/resize,s_${size * 2},m_lfit`;
    }
  }
  return { src: url, draggable: false };
})<Props>`
  object-fit: ${(props) => props.objectFit || 'cover'};;
`;

export default Image;
